(function(){
    angular
        .module('appback')
        .directive('ngUrianalisis', urianalisis);

        urianalisis.$inject = ['ResultadosService','$timeout'];
        function urianalisis(ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=urianalisis.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  centro: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	if(!scope.item.resultado.extra){
		            		scope.item.resultado = { extra : { resultado : { cristales:[{}] }}};
		            		console.log(scope.item.resultado.extra);
			            }else{
		            		console.log("aki2");
			            	if(!scope.item.resultado.extra.resultado.cristales){
			            		scope.item.resultado.extra.resultado.cristales = [{}];
			            	}else{
			            		//SI NO EXISTE LE AÑADIMOS COMO OBJETO
			            		for(var cont = 0;cont<scope.item.resultado.extra.resultado.cristales.length;cont++){
			            			if(typeof(scope.item.resultado.extra.resultado.cristales[cont].cristal)=='undefined' && typeof(scope.item.resultado.extra.resultado.cristales[cont].resultado)=='undefined'){
			            				scope.item.resultado.extra.resultado.cristales[cont] = {};
			            			}
			            		}
			            		//scope.item.resultado.extra.resultado.cristales = JSON.parse(angular.toJson(scope.item.resultado.extra.resultado.cristales))
			            		//console.log(JSON.parse(angular.toJson(scope.item.resultado.extra.resultado.cristales)));

			            	}
			            }
			            console.log(scope.item.resultado);
		            	function format(icon) {
	                        var originalOption = icon.element;
	                          var str = "";
	                          if(typeof $(originalOption).data('icon') != 'undefined'){
	                            str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
	                            return $(str+" ");
	                          }else{
	                            return icon.text || icon.value;
	                          }
	                      }
		            	scope.loading = true;
		            	//console.log(scope);
		            	scope.subanaliticas = [];
		            	ResultadosService.getSubanaliticasByAnalitica(scope.item.analitica_id,scope.animal.especie_id,scope.centro.idioma_code,function(data){
			               scope.subanaliticas = data.subanaliticas;
                    		scope.loading = false;
			            });
			            scope.borrarCristal = function(i){
			            	scope.item.resultado.extra.resultado.cristales.splice(i,1);
			            }
			            scope.nuevoCristal = function(){
			            	scope.item.resultado.extra.resultado.cristales.push({});
			            }
			            scope.optionsAtributos = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/select2atributos",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'valoresatt'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}
			        });
		        }
          }
      }
})();